import { render } from "./user-locks-popup.vue?vue&type=template&id=b04a5bda"
import script from "./user-locks-popup.vue?vue&type=script&setup=true&lang=js"
export * from "./user-locks-popup.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/administration/users/user-locks-popup.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b04a5bda"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b04a5bda', __exports__)) {
    api.reload('b04a5bda', __exports__)
  }
  
  module.hot.accept("./user-locks-popup.vue?vue&type=template&id=b04a5bda", () => {
    api.rerender('b04a5bda', render)
  })

}


export default __exports__